// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const count_WIKI_ARTICLE_EXPERIENCES = ["%(count)s zku\u0161enost", "%(count)s zku\u0161enosti", "%(count)s zku\u0161enost\u00ed"];
export const RELATED_REVIEW_ARTICLES = "Recenze souvisej\u00edc\u00edch produkt\u016f";
export const TO_REVIEW_CENTRE = "do Centra recenz\u00ed";
export const WIKI_WRITE_YOUR_EXPERIENCE = "Napi\u0161 svou zku\u0161enost";
export const WIKI_WRITE_YOUR_FIRST_EXPERIENCE = "Bu\u010f prvn\u00ed a napi\u0161 zku\u0161enost";
